<template>
  <pt-detection-package-list class="pt-detection-package-list__page"></pt-detection-package-list>
</template>

<script>
import PtDetectionPackageList from 'cps/gene-product/pt-detection-package-list/withData'
export default {
  name: 'pt-detection-package-list__view',
  components: {
    'pt-detection-package-list': PtDetectionPackageList
  }
}
</script>
